import { useRef, useEffect } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

interface UseScrollScaleProps {
  targetSelector: string | gsap.TweenTarget
  scrollerSelector?: string
  start?: string
  end?: string
  scrub?: boolean | number
  enableScrollScale?: boolean
}

const useScrollScale = ({
  targetSelector,
  scrollerSelector = '#main',
  start = 'top bottom',
  end = 'bottom bottom',
  scrub = true,
  enableScrollScale = true,
}: UseScrollScaleProps) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!enableScrollScale) return

    const container = containerRef.current
    if (!container) return

    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: scrollerSelector,
        trigger: container,
        start,
        end,
        scrub,
      },
    })

    tl.to(targetSelector, {
      transform: 'scale(1)',
    })

    return () => {
      tl.kill()
    }
  }, [targetSelector, scrollerSelector, start, end, scrub])

  return containerRef
}

export default useScrollScale
